module.exports = __webpack_public_path__ + "static/media/cscc_afternoon-tea.c3564013.jpg";